// eslint-disable-next-line
export default function noop() {}
